import { makeStyles } from "@mui/styles"

export const useOverrides = makeStyles({
  accordionRoot: {
    "&.MuiAccordion-root": {
      "&:before": {
        display: "none",
      },
      backgroundColor: "transparent",
      boxShadow: "none",
      padding: 0,
      width: "100%",
    },
  },
  detailsRoot: {
    "&.MuiAccordionDetails-root": {
      padding: 0,
    },
    display: "block",
    padding: 0,
  },
  summaryRoot: ({ withPaddings }) => ({
    "&.MuiAccordionSummary-root": {
      padding: withPaddings ? "0 30px" : "0",
    },
    "&[class*='Mui-expanded']": {
      margin: "0",
      minHeight: 44,
    },
    "&[class*='Mui-expanded']": {
      minHeight: 44,
    },
  }),
})

export const useDynamicOverrides = makeStyles(() => ({
  summaryContent: ({ withPaddings }) => ({
    "& svg": {
      position: "absolute",
      right: "18px",
      top: "11px",
    },
    "&.MuiAccordionSummary-content.Mui-expanded": {
      height: "44px",
      margin: "12px 0 12px",
      paddingLeft: withPaddings ? "30px" : "0",
      paddingRight: withPaddings ? "30px" : "0",
    },
    alignItems: "center",
    background: "#fff",
    border: "1px #d3d3d3 solid",
    borderRadius: "4px",
    color: "#333",
    fontSize: "14px",
    fontWeight: "bold",
    height: "44px",
    justifyContent: "center",
    paddingLeft: withPaddings ? "30px" : "0",
    paddingRight: withPaddings ? "30px" : "0",
    position: "relative",
  }),
}))

export const useDynamicDetailsOverrides = makeStyles(() => ({
  root: ({ contentHeight, verticalOverflow, withPaddings }) => ({
    "&.MuiAccordionDetails-root": {
      fontSize: "14px",
      padding: withPaddings ? "0 0 0 30px" : "0",
    },
    display: "block",
    height: contentHeight,
    overflowY: verticalOverflow,
    width: "calc(100% - 30px)",
  }),
}))
